import { Helmet } from 'react-helmet'

import { Button } from '@/components/ui/button'

export function NotFound() {
  return (
    <>
      <Helmet>
        <title>Page not found</title>
      </Helmet>
      <div className="bg-ink-50 flex min-h-screen flex-col items-center justify-center px-5.5 text-center">
        <div className="reveal-in-view">
          <span className="eyebrow rounded-sm">404</span>
        </div>
        <h1 className="h2 mt-6">This route doesn&apos;t exist</h1>
        <p className="text-md text-ink-500 mt-4 max-w-md leading-[1.55]">
          The page you were looking for may have moved or never existed.
        </p>
        <Button href="/" className="mt-8">
          Back to home
        </Button>
      </div>
    </>
  )
}
